<template>
    <modal :show="show" @close="close" :closeOnbackdrop="false">
        <template slot="header"><h3>Checkout - Step {{ step }}/{{ stepLimit }}</h3></template>
        <template>
            <div v-show="step == 1">
                <shipping-detail @data="getShippingDetail" :customer_details="customer_details" :done="shippingDetailSelectDone" :backorder="backorder" :spare="true"></shipping-detail>
                <payment-method @data="getPaymentMethod" :customer_details="customer_details" :done="paymentMethodSelectDone"></payment-method>
            </div>
            <div v-show="step == 2">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 20%;">Product</th>
                            <th style="width: 20%;">Price</th>
                            <th style="width: 10%;">Quantity</th>
                            <th style="width: 25%;">Description</th>
                            <th style="width: 20%;">Subtotal</th>
                            <th style="width: 5%;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in items" :key="row.id">
                            <td>{{ row.item }}</td>
                            <td class="text-center">${{ price_format(row.price) }} USD</td>
                            <td><input type="number" class="form-control quantity" v-model="row.quantity" :value="row.quantity" min="1" @change="update_total(row)"></td>
                            <td>{{ row.description }}</td>
                            <td class="text-right">${{ price_format(row.total) }} USD</td>
                            <td class="text-center"><a href="javascript:void(0);" @click="remove(row.id)"><span class="fa fa-remove"></span></a></td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td class="text-right" colspan="4">Subtotal</td>
                            <td class="text-right">${{ price_format(subtotal) }} USD</td>
                        </tr>
                        <tr>
                            <td class="text-right" colspan="4">CC Fee</td>
                            <td class="text-right">${{ price_format(cc_fee) }} USD</td>
                        </tr>
                        <tr v-if="myTax > 0">
                            <td class="text-right" colspan="4">Tax</td>
                            <td class="text-right">${{ price_format(myTax) }} USD</td>
                        </tr>
                        <tr>
                            <td class="text-right" colspan="4">Discount</td>
                            <td class="text-right">${{ price_format(discount) }} USD</td>
                        </tr>
                        <tr>
                            <td class="text-right" colspan="4">Total</td>
                            <td class="text-right">${{ price_format(total) }} USD</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </template>
        <template slot="footer">
            <button v-show="step > 1" class="btn" type="button" @click="prevStep">Back</button>
            <button class="btn btn-black" type="button" :disabled="isStepLoading" @click="nextStep">
                <template v-if="step < stepLimit">
                    <template v-if="isStepLoading"><span class="fa fa-spinner fa-pulse"></span></template>
                    <template v-else>Next</template>
                </template>
                <template v-if="step == stepLimit">
                    <template v-if="isStepLoading"><span class="fa fa-spinner fa-pulse"></span></template>
                    <template v-else>Confirm</template>
                </template>
            </button>
        </template>
    </modal>
</template>
<script>
import ShippingDetail from '../../components/ShippingDetail.vue'
import PaymentMethod from '../../components/PaymentMethod.vue'

export default {
    data() {
        return {
            isStepLoading: false,
            layout: '',
            step: 1,
            stepLimit: 2,
            items: [],
            subtotal: 0,
            discount_percentage: 0,
            discount: 0,
            cc_fee: 0,
            total: 0,
            shippingDetailSelectDone: false,
            shippingDetail: {},
            paymentMethodSelectDone: false,
            paymentMethod: {},
            customer_details: {},
            backorder: false,
            edited_cart: false,
            myTax: 0
        }
    },
    components: {
        ShippingDetail,
        PaymentMethod
    },
    props: {
        show: Boolean
    },
    mounted() {
        let user = localStorage.getItem('user')
        if(!user) {
            this.layout = 'guest'
        } else {
            this.get_customer_details()
        }
    },
    watch: {
        show(n) {
            if(n) {
                this.step = 1
                let cart = localStorage.getItem('cart')
                if(cart) {
                    this.items = JSON.parse(cart)
                }
                this.get_discount()
                this.check_backorder()
                this.getTax()
            }
        }
    },
    methods: {
        nextStep() {
            let fdata = new FormData()
            let now = new Date

            switch(this.step) {
                case 1: { // Payment
                    this.isStepLoading = true
                    this.shippingDetailSelectDone = now.getTime()
                    this.paymentMethodSelectDone = now.getTime()

                    setTimeout(() => {
                        if(this.shippingDetail.validated && this.paymentMethod.validated) {
                            this.step = 2
                            this.calculate()
                        } else {
                            alert('Please fill all required data.')
                        }
                        this.isStepLoading = false
                        this.edited_cart = false
                    }, 1000)
                    break;
                }
                case 2: { // Confirm
                    this.isStepLoading = true
                    delete this.shippingDetail.validated
                    delete this.paymentMethod.validated

                    // append shipping details to form data
                    for(let prop in this.shippingDetail) {
                        fdata.append(prop, this.shippingDetail[prop])
                    }
                    //end

                    // append payment method to form data
                    for(let prop in this.paymentMethod) {
                        if(this.paymentMethod.payment_type == 'po' && prop == 'po') {
                            let po = this.paymentMethod[prop]
                            fdata.append('po_number', po.number)
                            Array.from(po.file).forEach(file => {
                                fdata.append('po_file[0][]', file, file.name)
                            })
                        } else {
                            fdata.append(prop, this.paymentMethod[prop])
                        }
                    }
                    // end

                    fdata.append('items', JSON.stringify(this.items))
                    fdata.append('layout', this.layout)

                    if(this.edited_cart) {
                        let cur_backorder_status = this.backorder

                        // recheck backorder
                        this.check_backorder().then(() => {
                            if(this.backorder && !cur_backorder_status) {
                                alert('Purchased quantity exceeds stock availability, please allow 12 weeks for delivery.')
                                this.step = 1
                                this.isStepLoading = false
                            } else {
                                this.purchase(fdata)
                            }
                        })
                    } else {
                        this.purchase(fdata)
                    }
                    break;
                }
            }
        },
        prevStep() {
            if(this.step > 1) {
                this.step--
            }
        },
        getPaymentMethod(data) {
            this.paymentMethod = data
        },
        getShippingDetail(data) {
            this.shippingDetail = data
        },
        get_discount() {
            this.$http.post('/api/spare-parts/user_discount', { layout: this.layout })
                .then((response) => {
                    this.discount_percentage = response.data.discount
                })
        },
        getTax() {
            this.$http.get('/api/spare-parts/my-tax')
            .then((response) => {
                this.myTax = parseFloat(response.data.my_tax)
            }).catch(error => {
                console.log(error)
            })
        },
        calculate() {
            let subtotal = 0
            let discount = 0
            let cc_fee = 0
            let total = 0

            for(let x in this.items) {
                subtotal = parseFloat(subtotal) + parseFloat(this.items[x].total)
            }
            if(this.paymentMethod.payment_type == 'credit-card') {
                cc_fee = parseFloat(subtotal) * (3.4/100) // TEMP
            }
            if(this.discount_percentage > 0) {
                discount = parseFloat(subtotal) * (parseFloat(this.discount_percentage)/100)
            }

            total = ((parseFloat(subtotal) + parseFloat(cc_fee) + parseFloat(this.myTax)) - parseFloat(discount))

            this.subtotal = subtotal.toFixed(2)
            this.discount = discount.toFixed(2)
            this.cc_fee = cc_fee.toFixed(2)
            this.total = total.toFixed(2)

            if(total <= 0) {
                this.close()
            }
        },
        close() {
            this.show = false
            this.$emit('close', true)
        },
        get_customer_details() {
            this.$http.get('/api/purchase/get-details', {})
                .then((response) => {
                    this.customer_details = response.data
                })
        },
        check_backorder() {
            return this.$http.post('/api/spare-parts/check_backorder', { items: this.items })
                .then((response) => {
                    this.backorder = response.data.backorder
                })
        },
        update_total(row) {
            if(row.quantity > 0) {
                let total = parseFloat(row.price) * parseInt(row.quantity)
                row.total = total.toFixed(2)
                localStorage.setItem('cart', JSON.stringify(this.items))
                this.calculate()
            } else {
                this.remove(row.id)
            }

            this.edited_cart = true
        },
        remove(id) {
            for(let x in this.items) {
                if(this.items[x].id == id) {
                    this.items.splice(x, 1)
                    break
                }
            }
            localStorage.setItem('cart', JSON.stringify(this.items))
            this.calculate()

            if(this.items.length == 0) {
                this.close()
            }

            this.edited_cart = true
        },
        price_format(num) {
            return Number(num).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        purchase(fdata) {
            this.$http.post('/api/spare-parts/purchase', fdata, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then(() => {
                    alert('Your order has been received!')
                    this.isStepLoading = false
                    this.$emit('success', true)
                })
                .catch((error) => {
                    if(error.response.data.message == 'failed') {
                        alert('Something went wrong!')
                    } else {
                        alert(error.response.data.message)
                    }
                    this.isStepLoading = false
                })
        }
    }
}
</script>
<style lang="scss" scoped>
.modal::v-deep {
    .modal-dialog {
        max-width: 992px;
    }
}
.table {
    th, td {
        font-size: 11px;
        font-weight: normal;
        width: auto;
    }
    tfoot {
        td {
            border: 0;
            color: #000;
            padding: 0.8em 1em;
            font-weight: bold;
            font-size: 12px;
        }
    }
}
.quantity {
    font-size: 11px;
    width: 4.5em;
    padding: 4px;
    height: auto;
    display: inline-block;
    font-weight: bold;
}
</style>